import { useState } from 'react';

const KEYS = ['1', '2', '3', '4', '5', '6', '7', '8', '9', 'C', '0', '⌫'] as const;

/** Кассир зовёт старшего: тот вводит свой PIN, действие получает имя одобрившего. */
export function ElevateDialog({ title, onConfirm, onCancel }: {
  title: string;
  onConfirm: (pin: string) => Promise<string | null>; // имя менеджера | null = не подошёл
  onCancel: () => void;
}) {
  const [pin, setPin] = useState('');
  const [err, setErr] = useState('');
  const [busy, setBusy] = useState(false);

  const press = async (k: string) => {
    setErr('');
    if (k === 'C') return setPin('');
    if (k === '⌫') return setPin((p) => p.slice(0, -1));
    const next = (pin + k).slice(0, 4);
    setPin(next);
    if (next.length === 4) {
      setBusy(true);
      const approver = await onConfirm(next);
      setBusy(false);
      if (approver === null) { setPin(''); setErr('PIN не подошёл'); }
    }
  };

  return (
    <div className="dialog-backdrop" role="dialog" aria-modal="true" aria-label={title}>
      <div className="dialog">
        <span className="eyebrow">Нужен менеджер</span>
        <h1>{title}</h1>
        <div className="pin-dots">
          {[0, 1, 2, 3].map((i) => <i key={i} className={i < pin.length ? 'on' : ''} />)}
        </div>
        <p className="error">{err}</p>
        <div className="numpad">
          {KEYS.map((k) => (
            <button key={k} className="btn" disabled={busy} onClick={() => press(k)}>{k}</button>
          ))}
        </div>
        <button className="btn ghost" onClick={onCancel}>Отмена</button>
      </div>
    </div>
  );
}
